<template>
  <v-dialog
    v-model="set_strategy_dialog"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    max-width="400"
  >
    <v-card v-if="strategy_to_edit">
      <v-card-title center class="headline justify-center">
        {{ $t("Edit_strategy") }}
      </v-card-title>
      <v-card-text>
        <v-form ref="edit_strategy_form" v-model="edit_strategy_form">
          <v-row>
            <v-col cols="12">
              <v-text-field
                v-model="strategy_to_edit.name"
                :label="$t('Name')"
                :rules="[v => !!v || $t('required')]"
                outlined
                rounded
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-textarea
                v-model="strategy_to_edit.description"
                :label="$t('description')"
                outlined
                rounded
                dense
                hide-details
              ></v-textarea>
            </v-col>
            <v-col v-if="isAddingStrategy" cols="12" md="6">
              <v-select
                v-model="strategy_to_edit.rate_plan_id"
                :label="$t('_rate')"
                :items="strategy_rates"
                item-text="code"
                item-value="id"
                :rules="[v => !!v || $t('required')]"
                outlined
                rounded
                dense
                hide-details
              ></v-select>
            </v-col>
            <v-col cols="12">
              <label class="d-block mb-2">
                {{ $t("color") }}
              </label>
              <a-color-palette v-model="strategy_to_edit.color" />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions class="ps-5 pb-5 justify-center">
        <v-btn
          :disabled="!edit_strategy_form"
          color="secondary"
          rounded
          class="pl-5 pr-5"
          @click="updateStrategy()"
        >
          {{ isAddingStrategy ? $t("add") : $t("update") }}
        </v-btn>
        <v-btn
          color=""
          text
          rounded
          depressed
          class="pl-5 pr-5"
          @click="closeDialog()"
        >
          {{ $t("cancel") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import aColorPalette from "@/components/aColorPalette.vue";
import * as Utils from "@/utils.js";
import { mapGetters, mapState } from "vuex";

export default {
  name: "a-pricing-strategy-set-strategy-dialog",
  components: {
    aColorPalette
  },
  data: () => ({
    edit_strategy_form: false,
    strategy_color_menu: false
  }),
  computed: {
    strategy_to_edit: {
      get() {
        return this.$store.state.pricingstrategy.strategy_to_edit;
      },
      set(value) {
        this.$store.dispatch("setPricingStrategyStrategyToEdit", value);
      }
    },
    set_strategy_dialog: {
      get() {
        return this.$store.state.pricingstrategy.set_strategy_dialog;
      },
      set(value) {
        this.$store.dispatch("setPricingStrategySetStrategyDialog", value);
      }
    },
    isAddingStrategy() {
      return !this.strategy_to_edit.id;
    },
    ...mapState({
      strategy: state => state.pricingstrategy.strategy,
      strategy_rates: state => state.pricingstrategy.strategy_rates,
      strategy_room_types: state => state.pricingstrategy.strategy_room_types,
      anticipation_slots: state => state.pricingstrategy.anticipation_slots
    }),
    ...mapGetters({
      current_hotel: "current_hotel",
      getPricingStrategyStrategyRatePlanById:
        "getPricingStrategyStrategyRatePlanById"
    })
  },
  methods: {
    showEditStrategy() {
      this.show_edit_strategy = true;
      this.strategy_to_edit = JSON.parse(JSON.stringify(this.strategy));
    },
    closeDialog() {
      this.set_strategy_dialog = false;
      this.strategy_to_edit = null;
    },
    updateStrategy() {
      this.$store.dispatch("setSnackbar", {
        title: this.$t("updating_strategy"),
        color: "secondary"
      });
      this.strategy_to_edit.strategy_id = this.strategy_to_edit.id;
      this.$store
        .dispatch("setPricingStrategyStrategy", this.strategy_to_edit)
        .then(response => {
          this.$store.dispatch("setSnackbar", {
            title: this.$t("strategy_updated"),
            color: "accent"
          });
          this.closeDialog();
          this.$emit("updatedStrategy", response.data.id);
        })
        .catch(() => {
          this.closeDialog();
          Utils.showError(this, "strategy_not_updated");
        });
    }
  }
};
</script>
